<!-- @veltra/icons generated sha256:a42f689be3ccfa94 gen:8 source:src/svg/normal/camera.svg -->
<script setup lang="ts">
defineOptions({ name: 'Camera' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M5.554 2.267a.6.6 0 0 1 .5-.267h3.892c.201 0 .388.1.5.267l.674 1.012c.093.139.25.221.418.221h2.452a.51.51 0 0 1 .51.51v8.48a.51.51 0 0 1-.51.51H2.01a.51.51 0 0 1-.51-.51V4.01a.51.51 0 0 1 .51-.51h2.452a.5.5 0 0 0 .418-.221zM9.732 3H6.268l-.851 1.276a.5.5 0 0 1-.414.224H2.996A.496.496 0 0 0 2.5 5v6.5c0 .277.215.5.49.5h10.02c.275 0 .49-.223.49-.5V5c0-.277-.22-.5-.496-.5h-2.007a.5.5 0 0 1-.414-.224zM8 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-5a2 2 0 1 1 0 4 2 2 0 0 1 0-4"
    />
  </svg>
</template>
